import getNextConfig from 'next/config'
const {
  publicRuntimeConfig: { DOMAIN_URL },
} = getNextConfig()

const getCanonicalUrl = subUrl => {
  const fullUrl = `${DOMAIN_URL}${subUrl}`
  const url = new URL(fullUrl)
  const tagValue = url.searchParams.get('tag') // Get the 'tag' value
  url.search = '' // Clear all query params
  if (tagValue) {
    url.searchParams.set('tag', tagValue) // Re-add only 'tag'
  }
  return url.toString()
}

export default getCanonicalUrl
